import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 3H3v18h18V3zM10 17l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBoxSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CheckBoxSharp.js
// module id = 2762
// module chunks = 2